import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Link from "next/link";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Image from "next/image";
import I1 from "@/public/static/images/instrument/in-1.png";
import I2 from "@/public/static/images/instrument/in-2.png";
import I3 from "@/public/static/images/instrument/in-3.png";
import I4 from "@/public/static/images/instrument/in-4.png";
import I5 from "@/public/static/images/instrument/in-5.png";
import I6 from "@/public/static/images/instrument/in-6.png";
import I7 from "@/public/static/images/instrument/in-7.png";
import I8 from "@/public/static/images/instrument/in-8.png";
import I9 from "@/public/static/images/instrument/in-9.png";
import I10 from "@/public/static/images/instrument/in-10.png";

function ListImage() {
  return (
    <div className="row">
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I1}
                alt="ZENIYA (THAILAND) CO.,LTD."
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                250 ton Transfer Stamp
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I2}
                alt="ZENIYA (THAILAND) CO.,LTD."
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                150 ton Auto Transfering Stamp
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I3}
                alt="ZENIYA (THAILAND) CO.,LTD."
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                Milling (milling, 3D shape machining)
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I4}
                alt="ZENIYA (THAILAND) CO.,LTD."
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                Air blast machine
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I6}
                alt="ZENIYA (THAILAND) CO.,LTD."
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                CNC for tool making
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I7}
                alt="ZENIYA (THAILAND) CO.,LTD."
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                Anodizing Line (mass production) 2lines
              </Typography>
              <div>
                <ul>
                  <li>5 color tanks per line</li>
                  <li>Chemical polish tank equipped</li>
                  <li>Silver and color anodizing</li>
                  <li>Product size max 1,200x 900mm</li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I8}
                alt="ZENIYA (THAILAND) CO.,LTD."
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                Anodizing Line (Small sized products and trial)
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I9}
                alt="ZENIYA (THAILAND) CO.,LTD."
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                CMM
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I10}
                alt="ZENIYA (THAILAND) CO.,LTD."
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                Printing machine
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}
export default ListImage;
